import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _withScopeId = n => (_pushScopeId("data-v-535671e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "doctor-page common-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, "医生管理", -1));
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "doctor-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-empty"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "no-data",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "empty-text"
}, "暂无数据")], -1));
import { reactive, ref, markRaw } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getDoctorDepListApi, getDoctorListApi, addDoctorApi, deleteDoctorApi } from "@/service/modules/case";
import { addLoading } from "@/utils/element-method";
import protoPagination from "@/components/proto-pagination.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { QuestionFilled } from "@element-plus/icons-vue";
import doctorDialog from "./components/doctor/doctor-dialog.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'doctor',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const doctorDepList = ref([]);
    const doctorList = ref([]);
    const doctorTableFirst = ref(true);
    const total = ref(0);
    const page = reactive({
      page: 1,
      pageSize: 15
    });
    const form = reactive({
      dept_id: null,
      name: "",
      status: null
    });
    const doctorDialogVisible = ref(false);
    const doctorDialogType = ref("add");
    const doctorDialogData = ref({});
    getDoctorDepList();
    async function getDoctorDepList() {
      try {
        let res = await getDoctorDepListApi();
        doctorDepList.value = res.data;
      } catch {}
    }
    function getDeptName(id) {
      let item = doctorDepList.value.find(item => item.id === id);
      if (item) {
        return item.name;
      } else {
        return "-";
      }
    }
    getDoctorList();
    async function getDoctorList() {
      const loadingInstance = addLoading(".doctor-list");
      let params = {
        ...page,
        ...form
      };
      try {
        let res = await getDoctorListApi(params);
        doctorList.value = res.data.data;
        total.value = res.data.total;
        if (doctorTableFirst.value) doctorTableFirst.value = false;
      } catch {} finally {
        loadingInstance.close();
      }
    }
    function restDoctorList() {
      page.page = 1;
      getDoctorList();
    }
    const set_display = async (id, value) => {
      let reqdata = {
        id,
        display_order: value
      };
      let res = await addDoctorApi(reqdata);
      ElMessage.success("操作成功");
      restDoctorList();
    };
    function handleClearDoctorList() {
      form.name = "";
      form.dept_id = null;
      form.status = null;
      page.page = 1;
      getDoctorList();
    }
    async function handleChangeDoctorStatus(item) {
      // console.log('item', item)
      let params = {
        id: item.id,
        status: item.status
      };
      try {
        await addDoctorApi(params);
        ElMessage.success("操作成功");
        restDoctorList();
      } catch {
        restDoctorList();
      }
    }
    function handleDeleteDoctor(id) {
      ElMessageBox.confirm("此操作将永久删除该数据, 是否继续？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          await deleteDoctorApi(id);
          ElMessage.success("删除成功");
          restDoctorList();
        } catch {}
      }).catch(() => {});
    }
    function handleDoctorTableCurrentChange(val) {
      page.page = val;
      getDoctorList();
    }
    function handleDoctorDialog(type, item) {
      doctorDialogType.value = type;
      if (item) doctorDialogData.value = item;
      doctorDialogVisible.value = true;
    }
    function handleCloseDoctorDialog() {
      doctorDialogVisible.value = false;
      doctorDialogType.value = "add";
      doctorDialogData.value = {};
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        inline: true,
        model: form,
        class: "flex"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "医生姓名"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            style: {
              "width": "180px"
            },
            modelValue: form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
            placeholder: "请输入医生姓名",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "科室筛选"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            placeholder: "请选择科室",
            modelValue: form.dept_id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.dept_id = $event),
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doctorDepList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 256))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "状态筛选"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            placeholder: "请选择状态",
            modelValue: form.status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.status = $event),
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "上架",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "下架",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: handleClearDoctorList
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: restDoctorList
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {
            "margin-left": "auto"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = $event => handleDoctorDialog('add'))
          }, {
            default: _withCtx(() => [_createTextVNode("新增医生")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_4, [!doctorTableFirst.value ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: doctorList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        empty: _withCtx(() => [_hoisted_5]),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          width: "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (page.page - 1) * page.pageSize), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "医生姓名",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "科室",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(getDeptName(scope.row.dept_id)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "排序"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input, {
            style: {
              "width": "100px"
            },
            modelValue: scope.row.display_order,
            "onUpdate:modelValue": $event => scope.row.display_order = $event,
            onChange: $event => set_display(scope.row.id, $event),
            type: "number"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "状态",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_switch, {
            modelValue: scope.row.status,
            "onUpdate:modelValue": $event => scope.row.status = $event,
            "inactive-value": 0,
            "active-value": 1,
            onChange: $event => handleChangeDoctorStatus(scope.row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "ct_time",
          label: "创建时间",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            type: "primary",
            style: {
              "margin-right": "10px"
            },
            onClick: $event => handleDoctorDialog('edit', scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => handleDeleteDoctor(scope.row.id)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])) : _createCommentVNode("", true), _createVNode(protoPagination, {
        page: page,
        total: total.value,
        onCurrentChange: handleDoctorTableCurrentChange
      }, null, 8, ["page", "total"])]), _createVNode(doctorDialog, {
        "dialog-visible": doctorDialogVisible.value,
        "dialog-type": doctorDialogType.value,
        "item-data": doctorDialogData.value,
        "dept-list": doctorDepList.value,
        onCloseDialog: handleCloseDoctorDialog,
        onRestData: restDoctorList
      }, null, 8, ["dialog-visible", "dialog-type", "item-data", "dept-list"])]);
    };
  }
});